// extracted by mini-css-extract-plugin
export default {"container":"i1-z","heading":"j1-z","links":"k1-z","copy":"l1-z","subCopy":"m1-z","linksLeft":"n1-z","linksCenter":"o1-z","linksRight":"p1-z","link":"q1-z","onlyLink":"r1-z"};